import { useEffect, useState } from 'react';
import './DossierSecret.css';

// Pile de photos (easter egg du logo) : un clic passe la photo du dessus sous la pile.
const PHOTOS = ['/images/dossier-1.jpg', '/images/dossier-2.jpg', '/images/dossier-3.jpg'];
const ANGLES = [-3, 2.5, -1];

function DossierSecret({ onClose }) {
  const [dessus, setDessus] = useState(0);
  const suivante = () => setDessus((prev) => (prev + 1) % PHOTOS.length);

  useEffect(() => {
    const onKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="dossier-overlay" onClick={onClose}>
      <div
        className="dossier"
        role="dialog"
        aria-modal="true"
        aria-label="Dossier secret"
        onClick={(event) => event.stopPropagation()}
      >
        <span className="dossier-tampon">Top secret</span>
        <p className="dossier-titre">Dossier n° 190316 — ECCG Martigny</p>
        <button type="button" className="dossier-photos" onClick={suivante} aria-label="Photo suivante">
          {PHOTOS.map((src, i) => {
            // 0 = photo du dessus, puis de plus en plus bas dans la pile.
            const rang = (i - dessus + PHOTOS.length) % PHOTOS.length;
            return (
              <img
                key={src}
                src={src}
                alt={rang === 0 ? `Pièce à conviction n° ${i + 1}` : ''}
                className={rang === 0 ? 'dossier-photo-dessus' : ''}
                style={{ zIndex: PHOTOS.length - rang, rotate: `${ANGLES[i]}deg` }}
              />
            );
          })}
        </button>
        <p className="dossier-legende">
          Pièce à conviction n°&nbsp;{dessus + 1}/{PHOTOS.length}&nbsp;: les débuts d'un couple star.
          <br />
          <span className="dossier-astuce">Clique sur la photo pour voir la suivante.</span>
        </p>
        <button type="button" className="btn btn-primary" onClick={onClose}>
          Refermer le dossier
        </button>
      </div>
    </div>
  );
}

export default DossierSecret;
